import { render } from "./CollectionRevealedBadge.vue?vue&type=template&id=2559afe0&scoped=true"
import script from "./CollectionRevealedBadge.vue?vue&type=script&lang=js"
export * from "./CollectionRevealedBadge.vue?vue&type=script&lang=js"

import "./CollectionRevealedBadge.vue?vue&type=style&index=0&id=2559afe0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2559afe0"]])

export default __exports__